import React, { useEffect, useState } from "react";
import {
  getSongs,
  getTrendingSongs,
  getRecentSongs,
  getUserHistory,
  getGenres,
} from "../services/songService";
import { useNavigate } from "react-router-dom";
import api from "../../utils/api";

const Songs = () => {
  const [songs, setSongs] = useState([]);
  const [trendingSongs, setTrendingSongs] = useState([]);
  const [recentSongs, setRecentSongs] = useState([]);
  const [historySongs, setHistorySongs] = useState([]);

  const [genres, setGenres] = useState([]);
  const [genreSongs, setGenreSongs] = useState({});

  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  useEffect(() => {
    fetchSongs(1);
    fetchTrending();
    fetchRecent();
    fetchHistory();
    fetchGenres();
  }, []);

  const fetchSongs = async (pageNum) => {
    const data = await getSongs(pageNum, 20);
    if (data?.status) {
      if (pageNum === 1) setSongs(data.songs || []);
      else setSongs((prev) => [...prev, ...(data.songs || [])]);
    }
    setLoading(false);
  };

  const fetchTrending = async () => {
    const res = await getTrendingSongs();
    setTrendingSongs(res?.songs || []);
  };

  const fetchRecent = async () => {
    const res = await getRecentSongs();
    setRecentSongs(res?.songs || []);
  };

  const fetchHistory = async () => {
    const res = await getUserHistory();
    setHistorySongs(res?.songs || []);
  };

  // DYNAMIC GENRES
  const fetchGenres = async () => {
    try {
      const res = await getGenres();
      const genreList = res?.genres || [];

      setGenres(genreList);

      genreList.forEach(async (genre) => {
        const response = await api.get(`/client/song/category/${genre}`);

        setGenreSongs((prev) => ({
          ...prev,
          [genre]: response.data.songs || [],
        }));
      });
    } catch (err) {
      console.error(err);
    }
  };

  const handleLoadMore = () => {
    const nextPage = page + 1;
    setPage(nextPage);
    fetchSongs(nextPage);
  };

  const SongCard = (song) => (
    <div
      key={song.slug || song._id}
      style={{ minWidth: "180px", cursor: "pointer" }}
      onClick={() => navigate(`/song/${song.slug || song._id}`)}
    >
      <img
        src={song.thumbnailUrl}
        alt={song.title}
        style={{ borderRadius: "10px", width: "100%" }}
      />
      <p>{song.title}</p>
    </div>
  );

  const Section = (title, list) => {
    if (!list.length) return null;

    return (
      <div style={{ marginBottom: "30px" }}>
        <h2>{title}</h2>

        <div
          style={{
            display: "flex",
            gap: "15px",
            overflowX: "auto",
          }}
        >
          {list.map((song) => SongCard(song))}
        </div>
      </div>
    );
  };

  if (loading) return <p>Loading...</p>;

  return (
    <div style={{ padding: "20px" }}>
      
      {Section("Trending", trendingSongs)}

      {Section("Recent Uploads", recentSongs)}

      {historySongs.length > 0 &&
        Section("Continue Listening", historySongs)}

      {/* DYNAMIC GENRES */}
      {genres.map((genre) => {
        const list = genreSongs[genre] || [];
        if (!list.length) return null;

        return Section(genre, list);
      })}

      {/* ALL SONGS */}
      <h2>All Songs</h2>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))",
          gap: "20px",
        }}
      >
        {songs.map((song) => SongCard(song))}
      </div>

      <div style={{ textAlign: "center", marginTop: "20px" }}>
        <button onClick={handleLoadMore}>Load More</button>
      </div>
    </div>
  );
};

export default Songs;